import { ParamIds, Places } from 'src/Constants'
import UserManagerKeys from '../um_keys'

export class UserManagerFormKeys extends UserManagerKeys {
    get place() {
        return Places.userManagerForm
    }

    get userId() {
        return this._intent.getParameterAsNumber(ParamIds.userId)
    }

    set userId(value: number | undefined) {
        this._intent.setParameter(ParamIds.userId, value)
    }
}
